module.exports = __webpack_public_path__ + "img/cross_img.5bd12840.svg";